import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { MotivationFullDetails } from '../all-motivations/model/all-motivations.interface';
import { CultureDetails, Insight, InsightAggregationData, Insights, MotivationFullDetails, ScoreDetails, UserMotivationDetails } from '../../../all-motivations/model/all-motivations.interface';
import { APIS } from 'src/app/apis';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractMotivationsService {

  constructor() { }

  abstract getAllMotivations(): Observable<MotivationFullDetails[]>;

  abstract getMotivation(id: string): Observable<MotivationFullDetails>;

  abstract getMotivationsForUser(userId: string): Observable<UserMotivationDetails[]>;

  abstract getScoreForUser(counterpartId:string): Observable<ScoreDetails>;

  abstract getBulkScoresForUsers(counterpartIds:string): Observable<ScoreDetails[]>;

  abstract getInsightsForTeamMember(): Observable<Insights>;
  
  abstract getPartialMotivationDetails(motivationId:string): MotivationFullDetails;

  abstract getMotivationColor(id: string): string;

  abstract insightsForCounterpart (counterpartId: string): Observable<InsightAggregationData[]>;

  abstract insightsForSelf(): Observable<InsightAggregationData[]>;

  abstract getMotivationIconName(motivationId: string): string;

  abstract getMotivationName(motivationId: string): string;

  abstract reloadMotivationsMetaData(): void;

  abstract getCulture(id:string): Observable<CultureDetails> ;
}
